'use strict';

window.customElements.define('e-vce-positioner-base', require('./vce-positioner-base'));
window.customElements.define('e-vce-positioner-editable', require('./vce-positioner-editable'));
window.customElements.define('e-vce-positioner-block', require('./vce-positioner-block'));
window.customElements.define('e-vce-borderer', require('./vce-borderer'));
window.customElements.define('e-vce-dropline', require('./vce-dropline'));
